<script>
    import { createEventDispatcher } from 'svelte';
    import { quintOut } from 'svelte/easing';
    import { fade, slide } from 'svelte/transition';

    import { POPUP_CLOSE_IMG } from '../constants/imgList';

    import webp from '@/actions/webp';

    export let isOpen = false;
    export let title = '';
    export let content = '';
    const dispatch = createEventDispatcher();

    function closePopup() {
        document.body.style.overflow = '';
        document.body.style.touchAction = '';
        dispatch('close');
        isOpen = false;
    }

    function stopPropagation(e) {
        e.stopPropagation();
    }

    $: {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
            document.body.style.touchAction = 'none';
        }
    }
</script>

{#if isOpen}
    <div
        role={null}
        class="popup-overlay"
        on:click={closePopup}
        transition:fade={{ duration: 200 }}
    >
        <div
            class="popup-container"
            role={null}
            on:click={stopPropagation}
            transition:slide={{
                duration: 500,
                easing: quintOut,
                y: '100%'
            }}
        >
            <div class="popup-close">
                <img
                    role={null}
                    on:click={closePopup}
                    use:webp
                    src={POPUP_CLOSE_IMG}
                    alt=""
                />
            </div>
            <div role={null} class="popup-title">
                {#if title !== 'Reglas'}
                    {title}
                {/if}
            </div>
            <div class="popup-content">
                {@html content}
            </div>
        </div>
    </div>
{/if}

<style>
    .popup-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.6);
        z-index: 1000;
        display: flex;
        align-items: flex-end;
        touch-action: none;
    }

    .popup-container {
        margin: 0 auto;
        width: 7.5rem;
        max-width: 7.5rem;
        background: white;
        border-radius: 64px 64px 0 0;
        padding: 40px;
        box-sizing: border-box;
        max-height: 90vh;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    }

    .popup-container .popup-close img {
        width: 40px;
        height: 40px;
    }

    .popup-container .popup-title {
        font-family: DiDiSans-Pro-Bold;
        font-size: 48px;
        color: #0b0b0d;
        line-height: 64px;
        margin-bottom: 28px;
    }

    .popup-container .popup-content {
        overflow-y: auto;
        max-height: 800px;
        font-family: DiDiSans-Pro-Regular;
        font-size: 32px;
        color: #0b0b0d;
        line-height: 40px;
        padding-bottom: 20px;
    }
</style>
